export default {
  init() {
    this.marquees = [...document.querySelectorAll(".marquee")].map(
      (marquee) => {
        const inner = marquee.querySelector(".marquee__track");
        const animation = inner?.getAnimations()[0];

        if (!inner || !animation) return null;

        const state = {
          marquee,
          inner,
          animation,
          startX: 0,
          startTime: 0,
          pointerId: null,
          dragging: false,
        };

        state.onPointerDown = (event) => {
          state.pointerId = event.pointerId;
          state.startX = event.clientX;
          state.startTime = animation.currentTime ?? 0;
          state.dragging = false;
        };

        state.onPointerMove = (event) => {
          if (event.pointerId !== state.pointerId) return;

          const deltaX = event.clientX - state.startX;

          // Don't interfere with a normal click.
          if (!state.dragging) {
            if (Math.abs(deltaX) < 5) return;

            state.dragging = true;
            marquee.classList.add("is-dragging");
            marquee.setPointerCapture(event.pointerId);
          }

          const duration = animation.effect.getTiming().duration;
          const distance = inner.scrollWidth / 2;
          const msPerPixel = duration / distance;

          let newTime = state.startTime - deltaX * msPerPixel;

          newTime = ((newTime % duration) + duration) % duration;

          animation.currentTime = newTime;
        };

        state.onPointerUp = (event) => {
          if (event.pointerId !== state.pointerId) return;

          marquee.classList.remove("is-dragging");

          if (marquee.hasPointerCapture(event.pointerId)) {
            marquee.releasePointerCapture(event.pointerId);
          }

          state.pointerId = null;
          state.dragging = false;
        };

        marquee.addEventListener("pointerdown", state.onPointerDown);
        marquee.addEventListener("pointermove", state.onPointerMove);
        marquee.addEventListener("pointerup", state.onPointerUp);
        marquee.addEventListener("pointercancel", state.onPointerUp);

        return state;
      },
    );

    console.log(this.marquees);
  },

  destroy() {
    this.marquees?.forEach((state) => {
      const { marquee, onPointerDown, onPointerMove, onPointerUp } = state;

      marquee.removeEventListener("pointerdown", onPointerDown);
      marquee.removeEventListener("pointermove", onPointerMove);
      marquee.removeEventListener("pointerup", onPointerUp);
      marquee.removeEventListener("pointercancel", onPointerUp);
    });

    this.marquees = [];
  },
};
